export default __webpack_public_path__ + "static/media/dots.aaf197b7.svg";